<template>
  <div class="content content3">
      <p class="nav">#<span>基金分类</span></p>
      <ul class="fund-classify">
        <li v-for="(item, index) in fundList" :key="index">
          <div class="main">
            <div class="fund-title">{{item.title}}</div>
            <div class="fund-pic"><img :src="item.pic" alt=""></div>
            <div class="arrow"><img src="./arrow.png" alt=""></div>
            <div class="detail">{{item.detail}}</div>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
import fund1 from './fund1.png'
import fund2 from './fund2.png'
import fund3 from './fund3.png'
import fund4 from './fund4.png'
import fund5 from './fund5.png'

export default {
  name: 'FundClassify',
  data () {
      return {
          fundList: [
                {
                title: '亚商创投系列基金',
                pic: fund1,
                detail: '成长型企业投资的基金群,专注对成长型企业的投资和增值服务。'
                },
                {
                title: '亚商加速器系列基金',
                pic: fund2,
                detail: '早期创业投资基金群，专注对创业早中期企业的投资和增值服务。在国内主要经济中心城市设有分支机构和子基金，和各地政府引导基金合作，深耕当地企业。'
                },
                {
                title: '亚商新材料基金',
                pic: fund3,
                detail: '重点关注包括新材料及其相关产品和技术装备的早中期企业。'
                },
                {
                title: '亚商TMT行业基金',
                pic: fund4,
                detail: '以数字新媒体行业项目为主的早中期基金。'
                },
                {
                title: '亚商大健康行业基金',
                pic: fund5,
                detail: '以健康消费为核心，关注医疗器械、保健服务等大健康领域。'
                },
            ]
      }
  }
}
</script>

<style scoped>
.content3{
  padding: 105px 64px 120px 64px;
  min-width: 1200px;
  
}
.content3 .nav{
  padding: 0 120px 0px 174px;
}
.content3 .nav{
  font-size: 24px;
  color: #c70016;
  font-weight: 600;
  margin-bottom: 30px;
}
.content3 .nav span{
  font-weight: 600;
  color: #333367;
}
.content3 ul{
  width: 100%;
  display: table;
  table-layout: fixed;
  padding-top: 110px;
  /* height: 412px; */
}
.content3 ul li{ 
  border-radius: 4px;
  display: table-cell;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
}
.content3 ul li .main{
  /* width: 280px; */
  width: 92%;
  min-width: 230px;
  height: 460px;
  background: #fff;
  box-shadow: 0 0 16px 10px rgba(0, 0, 0, 0.03);
  display: inline-block;
  vertical-align: middle;
}
.content3{
  
  background: url('../../assets/bg_dot.png');
}
.content3 .fund-title{
  height: 68px;
  line-height: 68px;
  color: #fff;
  font-size: 25px;
  background: #333367;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: all 0.5s;
  -moz-transition: all 0.5s;
  margin-bottom: 26px;
}
.content3 .fund-pic{
  width: 230px;
  height: 130px;
  overflow: hidden;
  margin: 0 auto;
}
.content3 li:hover .fund-title{
  background: #cf001a;
}
.content3 li:hover{
  transform: translateY(-76px);
  -webkit-transform: translateY(-76px);
  -moz-transform: translateY(-76px);
}
.content3 .arrow{
  text-align: left;
  padding: 24px 0;
  margin-left: -10px;
}
.content3 .detail{
  padding: 0 50px;
  height: 156px;
  box-sizing: border-box;
  text-align: justify;
  font-size: 14px;
  color: #404040;
  line-height: 26px;
}
@media screen and (max-width: 1024px) {
  .content3{
    box-sizing: border-box;
  }
}
@media screen and (max-width: 1625px){
  .content3 .arrow{
    padding: 15px 0;
  }
  .content3 .detail{
    line-height: 20px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/fundClassify/fundClassify.vue